import ajax from '../common/ajax.jquery';
import toast from '../common/toast.jquery';
import queryToJson from '../../common/qureyToJson';
let md5 = require('../common/md5');
let sending = false;
import {REGISTER_SUBMIT_URL} from 'common/cons';
export function registerSubmit(url, data, param) {
  let settings = Object.assign({
    notToastCode: [],
  }, param);
  url=url||REGISTER_SUBMIT_URL
  return new Promise((resolve, reject) => {
    'use strict';
    if (sending) {
      reject({
        errCode: 9000,
        errInfo: '请勿重复提交',
      });
      return;
    }
    if (!data.mobile.toString().match(/^(86){0,1}1\d{10}$/)) {
      toast('请输入正确的手机号码');
      reject({
        errCode: -9001,
        errInfo: '请输入正确的手机号码',
      });
      return;
    }
    if (!data.smsCode.match(/^.{4,}$/)) {
      toast('请输入正确的短信验证码');
      reject({
        errCode: -9003,
        errInfo: '请输入正确的短信验证码',
      });
      return;
    }
    let dataJson = queryToJson();
    dataJson.href = location.origin + location.pathname;
    let param = Object.assign({
      os: 'h5',
      dataJson: JSON.stringify(dataJson),
      // inviterUid: window.jsonData.data.inviterUid,
      // inviterUidSign: window.jsonData.data.inviterUidSign
    }, data);
    if (!settings.hidePasswordbox) {
      if (!data.password.match(/^.{6,}$/)) {
        toast('请输入6位以上密码');
        reject({
          errCode: -9002,
          errInfo: '请输入6位以上密码',
        });
        return;
      }
    }
    param.password = md5(param.password);
    sending = true;
    ajax.post(url, {
      data: param,
      complete: e => {
        sending = false;
      },
    }).then(data => {
      if (typeof data == 'string') {
        data = JSON.parse(data);
      }
      let errInfo, errcode;
      if (data.ret || data.ret == 0) {
        errInfo = data.msg.replace(/<[^>]*>/g, '');
        errcode = data.ret;
      } else {
        errInfo = data.errstr.replace(/<[^>]*>/g, '');
        errcode = data.errcode;
      }

      if (errcode == 0) {
        resolve(data);
        return;
      } else if (errcode < 0) {
        switch (errcode) {
          case -1000:
            errInfo = '手机号无效';
            break;
          case -2000:
            errInfo = '您已是小赢用户 请直接登录';
            break;
          case -2001:
            errInfo = '邀请人无效';
            break;
          case -2999:
            errInfo = '验证码已失效，需重新获取';
            break;
          case -3000:
            errInfo = '验证码错误';
            break;
          case -5000:
            errInfo = '系统错误';
            break;
          case -6000:
            errInfo = '系统错误';
            break;
          case -7000:
            errInfo = '系统错误';
            break;
          case -20000:
            errInfo = '短信发送失败';
            break;
          default:
            break;
        }
      } else if (errcode == 101) {
        errInfo = '网络异常';
      }
      if (settings.notToastCode.indexOf(errcode) === -1) {
        toast(errInfo);
      }
      reject({
        errCode: errcode,
        errInfo,
      });

    }).catch((a, b, c) => {

      toast('网络错误，请稍候再试！');
      reject({
        errCode: -9000,
        errInfo: '网络错误，请稍候再试！',
      });
    });
  });
}
export default {
  registerSubmit,
};



// WEBPACK FOOTER //
// ./src/component/register/events.js